import { enableMainDropdownMenu } from './_dropdownMenu';

export const buildDropdownLinks = (response) => {
    const superCategories = response.superCats;
    let navUL = document.querySelector(".nav-append-links");
			
    if (superCategories.length > 0 && navUL) {        
        let dropdownHTML = '';
        superCategories.map((thisSuperCat, i) => {
            dropdownHTML += `
                <li class="superCatLink ${thisSuperCat.display == "Beauty" || thisSuperCat.display == "Just For You" ? "hide-when-international" : ""}">
                    <a aria-role="link" 
                        data-display="${thisSuperCat.display}"
                        data-twist="${thisSuperCat.display}"
                        aria-title="${thisSuperCat.display}"
                        manual_cm_sp="${thisSuperCat.manual_cm_sp}"
                        href="${thisSuperCat.link}"
                        class="parent-${i} oneClickOnly"
                    >
                        ${thisSuperCat.display}
                    </a>`;
                if(thisSuperCat.columns) {
                    dropdownHTML += `
                        <button class="hiddenButtonForNav" 
                            data-supername="${thisSuperCat.display}" 
                            aria-label="${thisSuperCat.display}"
                        >
                        </button>`;
                } else {
                    // added to fix spacing issues when link doesn't have a dropdown menu
                    dropdownHTML += `
                        <button class="dummy-hiddenButtonForNav"
                            tabindex="-1"
                        >
                        </button>`;
                }                                
			dropdownHTML += `</li>`;						
        });
		navUL.innerHTML = dropdownHTML;
    }    
    enableMainDropdownMenu(response);
};
